import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking or logged-out
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch (e) {
      setUser(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("moe_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signup = async (name, email, password, extras = {}) => {
    // iter93 (Item LL) — pass through T&C consent metadata (terms_accepted,
    // terms_version). Backend records them on the user doc so there's a real
    // server-side consent record, not just a UI gate.
    const { data } = await api.post("/auth/register", { name, email, password, ...extras });
    if (data.access_token) localStorage.setItem("moe_token", data.access_token);
    setUser(data.user);
    // Return the full response so the caller can inspect institutional_status
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("moe_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, signup, logout, refresh, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
